let mux_player_load_promise = null;

export function load_mux_player() {
    if (typeof window === 'undefined') {
        return Promise.resolve();
    }

    if (!mux_player_load_promise) {
        mux_player_load_promise = import('@mux/mux-player');
    }

    return mux_player_load_promise;
}

